import makeStyles from '@material-ui/core/styles/makeStyles';
import { PRIMARY_DARK, GRAY_LIGHT } from '@theme_color';

const useStyles = makeStyles(() => ({
    root: {
        '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
            // Default left padding is 6px
            padding: 4,
        },
        '& .MuiOutlinedInput-root': {
            border: '0px !important',
        },
    },
    paperAutocomplete: {
        borderRadius: 8,
        border: `1px solid ${GRAY_LIGHT}`,
        boxShadow: '0px 4px 6px -1px rgba(17, 24, 39, 0.10), 0px 2px 4px -1px rgba(17, 24, 39, 0.06)',
        margin: '5px 0',
        '&.no-padding': {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    optionAutocomplete: {
        color: PRIMARY_DARK,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px',
    },
}));

export default useStyles;
